import { rc } from "./rc";

export const employee_voice_single_company_multi_topic_trend = {
  rc,
};
